import { render, staticRenderFns } from "./PracticeListSort.vue?vue&type=template&id=1adce7ee&"
import script from "./PracticeListSort.vue?vue&type=script&lang=js&"
export * from "./PracticeListSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports